import { useState } from 'react'
import { Link2, Check } from 'lucide-react'
import { getPaperSongUrl } from '../lib/data'

interface ShareButtonProps {
  paperId: string
  className?: string
}

export default function ShareButton({ paperId, className = '' }: ShareButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleShare = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const url = `${window.location.origin}${getPaperSongUrl(paperId)}`

    // Try native share first (mobile)
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Paper2Song',
          url,
        })
        return
      } catch {
        // User cancelled or share failed, fall through to clipboard
      }
    }

    // Fall back to clipboard
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <button
      onClick={handleShare}
      className={`
        inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg h-8
        text-sm text-surface-300 hover:text-surface-100
        bg-surface-800 hover:bg-surface-700 transition-colors
        focus:outline-none focus:ring-2 focus:ring-accent-400
        ${className}
      `}
    >
      {copied ? (
        <>
          <Check size={14} className="text-accent-400" />
          <span>Copied!</span>
        </>
      ) : (
        <>
          <Link2 size={14} />
          <span>Share</span>
        </>
      )}
    </button>
  )
}

